import {configureStore} from '@reduxjs/toolkit';

import saga from '../sagas';
import {middleware, sagaMiddleware} from '../slices';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: !import.meta.env.MODE || import.meta.env.MODE === 'development',
});

if (import.meta.hot) {
  import.meta.hot.accept('./rootReducer', async () => {
    const {default: newRootReducer} = await import('./rootReducer');
    store.replaceReducer(newRootReducer);
  });
}

sagaMiddleware.run(saga);

export type AppDispatch = typeof store.dispatch;

export default store;
